<template>
<div v-if="width > 800" ref="carousel" :style="{ width: scrollContainerWidth}"
     class="relative z-10 inline-flex mt-6 space-x-6
    overflow-x-auto
    whitespace-nowrap
    [&::-webkit-scrollbar]:h-2
    [&::-webkit-scrollbar-track]:rounded-full
    [&::-webkit-scrollbar-track]:bg-[#D4D4D4]
    [&::-webkit-scrollbar-thumb]:rounded-full
    [&::-webkit-scrollbar-thumb]:bg-black
    scroller
"
>
    <slot/>
</div>

<div v-else ref="carousel" class="flex justify-center">
    <div :style="{ width: scrollContainerWidth}" class="relative z-10 inline-flex mt-6 space-x-6 overflow-x-scroll overflow-y-hidden">
        <slot/>
    </div>
</div>

</template>

<script>

import { ref, computed } from 'vue';
import { useWindowSize } from '@vueuse/core'

export default {

    props: {
        cardWidth: {
            type: Number
        },
        visibleCards: {
            type: Number
        },
        gridStructure: {
            type: Boolean,
            default: false
        }
    },

    setup() {
      const visibleCards = ref(2);
        const { width } = useWindowSize();
        const cardWidth = width.value;

        const carousel = ref("");
        const scrollAmount = ref(0);

        const isOnEnd = computed(() => {
            if(carousel.value) {
                return scrollAmount.value >= carousel.value.scrollWidth - ((visibleCards * cardWidth) - 50);
            }
        });

        const isOnStart = computed(() => {
            return scrollAmount.value <= 0;
        })

        const moveLeft = () => {
            if((scrollAmount.value - cardWidth) > 0) {
                scrollAmount.value -= cardWidth;
            } else {
                scrollAmount.value = 0;
            }
            carousel.value.scrollTo({
                top: 0,
                left: scrollAmount.value,
                behavior: 'smooth'
            })
        }

        const moveRight = () => {
            if((scrollAmount.value + cardWidth) < carousel.value.scrollWidth) {
                scrollAmount.value += cardWidth;
            } else {
                scrollAmount.value = carousel.value.scrollWidth;
            }
            carousel.value.scrollTo({
                top: 0,
                left: scrollAmount.value,
                behavior: 'smooth'
            })
        }

        const scrollContainerWidth = computed(() => {
            if(width.value > 800) {
              const newWidth = width.value - 180;
              if (newWidth >= 1600) {
                return '1440px'
              } else {
                return newWidth + 'px';
              }
            }

            if(width.value > cardWidth * 2) {
               return (cardWidth * 2) + "px";
            }

            if(width.value > cardWidth) {
               return cardWidth + "px";
            }
        })

        return {
            carousel,
            moveLeft,
            moveRight,
            isOnEnd,
            isOnStart,
            scrollContainerWidth,
            width
        }
    }
}
</script>

<style>
.scroller::-webkit-scrollbar-button:end:increment {
  width: 11%;
  display: block;
  background: transparent;
}
</style>
